import React from 'react';
import './HouseLocation.scss';
import { FcGoogle } from 'react-icons/fc';

const HouseLocation = ({ mapUrl, reviewUrl }) => {
  return (
    <div className='house-location'>
      <h2>Our Location</h2>
      <iframe
        title="House Location Map"
        src={mapUrl}
        height="450"
        frameBorder="0"
        style={{ border: 0, width: '100%' }}
        allowFullScreen=""
        aria-hidden="false"
        tabIndex="0"
      />
      <a href={reviewUrl} className='house-location__review'>
        <FcGoogle className='house-location__review--icon' />
        <p className='house-location__review--text'>
          review us on
          <br />
          <span className='house-location__review--text-big'>
            Google
          </span>
        </p>
      </a>
    </div>
  )
};

export default HouseLocation;
